import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import DataUpload from './pages/Dataupload';
import Preprocessing from './pages/Preprocessing';
import Analysis from './pages/Analysis';
import DifferentialAnalysis from './pages/DifferentialAnalysis'; 
import Results from './pages/Results';
import ExploratoryAnalysis from './pages/ExploratoryAnalysis';
import FunctionalAnalysis from './pages/Functional_Analysis'; 

// --- CONFIGURATION ---
// This is the link to the R server. Change this if the ngrok link expires.
const API_URL = "https://hooly-milliary-evonne.ngrok-free.dev/run_deseq2"; 
// ---------------------

function App() {
  const [currentPage, setCurrentPage] = useState('dataUpload');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [analysisRun, setAnalysisRun] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  
  // API Results: This box holds the images (Heatmap, Volcano) we get back from R
  const [apiResults, setApiResults] = useState(null);

  // File Data: This "Backpack" holds the text from the uploaded CSVs so we can send it later
  const [fileData, setFileData] = useState({
    counts_text: "",
    metadata_text: ""
  });

  const [preprocessing, setPreprocessing] = useState({
    normalize: false,
    standardize: false,
    removeMissing: false
  });

  // This function runs when you click "Run Analysis"
  const handleRunAnalysis = async () => {
    // Start the loading spinner
    setIsLoading(true);

    try {
      // Pack the data into a parcel to send to R
      const payload = {
        counts_text: fileData.counts_text,
        metadata_text: fileData.metadata_text,
        condition: "condition", // Default settings for now
        ref: "untreated",
        level: "treated",
        fdr: 0.05,
        lfc: 1.0
      };

      console.log("Sending request to:", API_URL);

      // Call the R server
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        // If successful, save the images and show the results page
        setApiResults(result.images);
        setAnalysisRun(true);
        setCurrentPage('results');
      } else {
        alert("API Error: " + result.error);
      }

    } catch (error) {
      console.error("Connection failed:", error);
      alert(`Failed to connect to ${API_URL}.\n\nIs the VM on?`);
    } finally {
      // Stop the loading spinner no matter what happens
      setIsLoading(false);
    }
  };

  const togglePreprocessing = (key) => {
    setPreprocessing(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="app-container">
      <Sidebar 
        sidebarOpen={sidebarOpen}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <div className="main-content-wrapper">
        <Header 
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        <div className="page-content">
          {/* We pass 'setFileData' so DataUpload page can save the files here */}
          {currentPage === 'dataUpload' && (
             <DataUpload setFileData={setFileData} />
          )}
          
          {currentPage === 'preprocessing' && <Preprocessing />}
          
          {currentPage === 'analysis' && (
            <Analysis
              preprocessing={preprocessing}
              togglePreprocessing={togglePreprocessing}
              handleRunAnalysis={handleRunAnalysis}
              isLoading={isLoading} // Pass loading state to show spinner
            />
          )}

          {currentPage === 'DifferentialAnalysis' && <DifferentialAnalysis />}
          {currentPage === 'ExploratoryAnalysis' && <ExploratoryAnalysis />}
          {currentPage === 'FunctionalAnalysis' && <FunctionalAnalysis />}
          
          {/* We pass 'apiResults' so Results page can show the real plots */}
          {currentPage === 'results' && (
            <Results 
              analysisRun={analysisRun} 
              apiResults={apiResults} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default App;